<div class="d-flex flex-row slider">
  <div class=" d-flex flex-row full-height" 
    *ngFor="let item of slider, let last = last;"
    [ngClass]="{'flex-g1' : last !== true}">
    <div class="d-flex align-items-center">
      <div class="d-flex center-point"
        placement="bottom" ngbTooltip="{{item.name}}"
        (click)="!item.selected && change(item)">
        <div *ngIf="item.i > currentStatus.i && last" 
          class="inner-point">
        </div>
        <img *ngIf="item.i <= currentStatus.i" 
          class="inner-checkmark"
          src="/assets/images/Check_Green.svg">
      </div>
    </div>
    <div class="d-flex align-items-center full-width path-container">
      <div class="d-flex align-items-center path"></div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/campaign-new/campaign-status-slider/campaign-status-slider.component.html